import { LocalStorage } from 'quasar'

export default function () {
  return {
    kycDefault: {
      kyc1: {
        type: 'kyc1',
        kyc_type: 'KYC Tahap 1',
        label: 'Grade C - Bisnis Tunai',
        document: {
          text: 'Pengajuan Pembayaran Bisnis Tunai',
          file: {}
        },
        status: 'Belum Ada Dokumen',
        message: 'Belum Ada Dokumen',
        isActive: true,
        isClickable: false,
        note: null,
        reason: null
      },
      kyc1_tempo: {
        type: 'kyc1_tempo',
        kyc_type: 'KYC Tahap 1',
        label: 'Grade C - Tempo',
        document: {
          text: 'Pengajuan Pembayaran Tempo',
          file: {}
        },
        status: 'Belum Ada Dokumen',
        message: 'Belum Ada Dokumen',
        isActive: true,
        isClickable: false,
        note: null,
        reason: null
      },
      kyc2: {
        type: 'kyc2',
        kyc_type: 'KYC Tahap 2',
        label: 'Grade B',
        document: {
          text: 'Pengajuan Kenaikan TOP dan Limit Kredit',
          file: {}
        },
        status: 'Belum Ada Dokumen',
        message: 'Belum Tersedia',
        isActive: false,
        isClickable: false,
        note: null,
        reason: null
      },
      kyc3: {
        type: 'kyc3',
        kyc_type: 'KYC Tahap 3',
        label: 'Grade A',
        document: {
          text: 'Pengajuan Kenaikan TOP dan  Limit Kredit',
          file: {}
        },
        status: 'Belum Ada Dokumen',
        message: 'Belum Tersedia',
        isActive: false,
        isClickable: false,
        note: null,
        reason: null
      }
    },

    initFetchData: true,
    mandatoryFields: ['name', 'email', 'phone', 'companyName', 'type'],

    termin: [7, 14, 30, 40, 45, 60, 75, 90],

    kycLimit: [
      {
        kyc_type: 1,
        limit: 100000000
      },
      {
        kyc_type: 2,
        limit: 5000000000
      },
      {
        kyc_type: 3,
        limit: 20000000000
      }
    ],

    isSubmitEditPressed: false,
    docsGradeFilter: LocalStorage.getItem('filter:customer-detail-grade'),
    docsGradeFilterCode: [],

    onDetailSubmission: null,

    customerInformation: {
      id: null,
      type: null,
      isVerified: null,
      name: null,
      companyId: null,
      companyName: null,
      businessType: null,
      isActive: null,
      currentGrade: null,
      bnplExternal: null
    },

    userInformation: {
      retail: null,
      business: {
        isDeleteSecondDirector: true,
        companyInformation: null,
        directorInformation: null,
        secondDirectorInformation: null,
        spouseInformation: null
      }
    },

    serverValidationErrors: {}
  }
}
